
import React, { ReactNode, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/auth';
import { Loader2 } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';

interface ProtectedAdminRouteProps {
  children: ReactNode;
}

export default function ProtectedAdminRoute({ children }: ProtectedAdminRouteProps) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  console.log('[ProtectedAdminRoute] Basic auth check:', {
    isLoading,
    hasUser: !!user,
    path: location.pathname,
    timestamp: new Date().toISOString()
  });

  // Show loading while auth state is being determined
  if (isLoading) {
    console.log('[ProtectedAdminRoute] Auth still loading, showing loading state');
    return (
      <div className="min-h-screen flex items-center justify-center app-background">
        <div className="flex items-center gap-2">
          <Loader2 className="h-6 w-6 animate-spin text-gold" />
          <span className="text-black">Checking authentication...</span>
        </div>
      </div>
    );
  }

  // Only check basic authentication - AdminLoginForm already verified admin status
  if (!user) {
    console.log('[ProtectedAdminRoute] User not authenticated, redirecting to admin login');
    return (
      <Navigate 
        to="/admin/login" 
        state={{ from: location }} 
        replace 
      />
    );
  }

  console.log('[ProtectedAdminRoute] Authentication verified, granting access', {
    hasUser: !!user,
    path: location.pathname
  });

  return <>{children}</>;
}
